var _path, _path2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickGuideSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H13C14.1046 1 15 1.89543 15 3V15C15 15.5523 14.5523 16 14 16H3C1.89543 16 1 15.1046 1 14V3C1 1.89543 1.89543 1 3 1Z",
    stroke: "#1847CA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H14.1176C14.605 12 15 12.395 15 12.8824V15.1176C15 15.605 14.605 16 14.1176 16H3C1.89543 16 1 15.1046 1 14C1 12.8954 1.89543 12 3 12Z",
    stroke: "#1847CA",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 2,
    height: 4,
    fill: "#1847CA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    width: 2,
    height: 4,
    fill: "#1847CA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 3,
    width: 2,
    height: 2,
    rx: 1,
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickGuideSmall);
export default __webpack_public_path__ + "static/media/quick-guide-small.28119fee08ac111362deb8a2ddb25388.svg";
export { ForwardRef as ReactComponent };